// extracted by mini-css-extract-plugin
module.exports = {"faqList":"FaqList_raffle_faqList__UIgSb","faqs":"FaqList_raffle_faqs__UDyDU","faqTitle":"FaqList_raffle_faqTitle__Vlz0p","sectionTitle":"FaqList_raffle_sectionTitle__ZFzmN"};